<template>
  <rest-list-action
    icon="el-icon-download"
    :title="$t('RestList_Action_Download')"
    :click="click"
  />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'
import { projectRoute } from '@/core/helpers'
export default {
  name: 'RestListActionDownload',

  components: { RestListAction },

  props: {
    endpoint: {
      type: Object,
      required: true
    },

    redirectRouteName: {
      type: String,
      required: false
    }
  },

  methods: {
    click() {
      RestApi(this.endpoint)
        .then(({ data }) => {
          if (this.redirectRouteName) {
            let redirectRoute = projectRoute({
              name: this.redirectRouteName,
              query: { id: data }
            })
            this.$router.push(redirectRoute)
          }
        })
        .catch(error => {
          if (error.response.status === 500) {
            this.$message({
              message: `${this.$t('Error_500Message')}`,
              type: 'error'
            })
          } else {
            this.$message({
              message: error.response.data.message,
              type: 'error'
            })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionDownload.vue